import { handleActions } from 'redux-actions';
import actions from '../actions';

const { enable, list, detail } = actions.preOrder;

const defaultDetail = {
  id: undefined,
  name: '',
  description: '',
  isDetailOpen: false,
  isSaved: false,
};

const defaultState = {
  list: [],
  isEnabled: false,
  isListOpen: false,
  ...defaultDetail,
};

const preOrder = handleActions(
  {
    [enable]: state => ({ ...state, isEnabled: true }),
    [list.toggle]: state => ({ ...state, isListOpen: !state.isListOpen }),
    [list.update]: (state, { payload }) => ({ ...state, list: payload }),
    [detail.toggle]: state => ({ ...state, isDetailOpen: !state.isDetailOpen }),
    [detail.reset]: state => ({ ...state, ...defaultDetail }),
    [detail.update]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  defaultState
);

export default preOrder;



// WEBPACK FOOTER //
// ./src/reducers/preOrder.js